// extracted by mini-css-extract-plugin
module.exports = {"root":"RegisterVerificationCodeError_root__2-cWx","modalHeader":"RegisterVerificationCodeError_modalHeader__iUTa4","modalBody":"RegisterVerificationCodeError_modalBody__S4ABZ"};